import styled from 'styled-components';
import { DOWN_ARROW } from '../../../Assets/images';

const SelectStyled = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
  transition: all 0.3s ease-in-out;

  .form-label {
    font-size: 16px;
    font-weight: 600;
  }
  .nativeSelect {
    position: relative;

    &:before {
      content: '';
      width: 35px;
      height: 50px;
      background: transparent url(${DOWN_ARROW.src}) no-repeat 35% 50% / 12px;
      position: absolute;
      top: 26px;
      right: 1px;
      z-index: 100;
      border: 1px solid transparent;
      pointer-events: none;
      border-radius: 0 8px 8px 0;
      opacity: ${(props) => (props.disabled ? '0.5' : '1')};
    }
  }

  .form-select {
    min-height: 65px !important;
    border-radius: 0px !important;
    border: none !important;
    border-bottom: 1px solid ${(props) => props.theme.color.border} !important;
    padding: 30px 8px 0px 4px !important;
    background-image: none !important;
    cursor: text;

    &.fullWidth {
      width: 100%;
    }

    &.select-placeholder {
      color: ${(props) => props.theme.text.medium};
    }

    & ~ label {
      padding-left: 0px !important;
      transform: scale(0.85) translateY(0) translateX(0.15rem);

      .form-label {
        font-size: 15px !important;
        font-weight: 600 !important;
        color: ${(props) => props.theme.text.medium} !important;
      }
    }

    &:focus {
      outline: none;
      box-shadow: 0 0 0;
      border-color: #1976d2 !important;
    }

    &.is-invalid {
      background-image: none !important;
      border-color: ${(props) => props.theme.verification.red.main} !important;
    }
  }

  .invalid-feedback {
    font-size: 15px !important;
    font-weight: 600;
    color: ${(props) => props.theme.verification.red.main};
    background: none !important;
    padding-left: 0 !important;
  }
`;

export default SelectStyled;
